import cx from "classnames";
import {Check, X} from "react-feather";
import React from "react";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles(() => ({
    resultQuestionAlternative: {
        display: "flex",
        alignItems: "center",
        borderRadius: "10px",
        padding: 10,
        gap: 8,
        "&.yourAnswer": {
            border: "4px solid #4485c1",
        },
    },
    srOnly: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0,
    },
}));

export const Answer = ({answer, idx, yourAnswer}) => {
    const classes = useStyles();
    const alternatives = ["a", "b", "c", "d", "e", "f"];

    return (
        <span
            className={cx(
                classes.resultQuestionAlternative,
                {
                    yourAnswer: answer.uniqueId === yourAnswer?.uniqueId,
                }
            )}
        >
            {`${alternatives[idx]?.toUpperCase() || ""}: ${
                answer.content
            }`}
            {answer.uniqueId === yourAnswer?.uniqueId && !answer.correct && (
                <>
                    <X color="#f87171" aria-hidden="true" />
                    <span className={classes.srOnly}>Ditt svar (feil)</span>
                </>
            )}
            {answer.correct && (
                <>
                    <Check color="#4ade80" aria-hidden="true" />
                    <span className={classes.srOnly}>Riktig svar</span>
                </>
            )}
        </span>
    );
};
